import React from "react";

export const LoadingPlanCards = () => {
  return (
    <div className="row g-3 justify-content-center w-100">
      {/* Skeleton para 2 cards de plano */}
      {[1, 2].map((item) => (
        <div key={item} className="col-12 col-md-6 col-lg-6 d-flex justify-content-center">
          <div 
            className="card h-100 shadow-sm border-0" 
            style={{ 
              borderRadius: '16px', 
              maxWidth: '320px',
              background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)'
            }}
          >
            <div className="card-body d-flex flex-column p-4">
              {/* Skeleton para ícone */}
              <div className="text-center mb-3">
                <div 
                  className="placeholder-glow mb-3 d-flex justify-content-center"
                >
                  <div 
                    className="placeholder rounded-circle"
                    style={{ width: '64px', height: '64px', backgroundColor: '#e9ecef' }}
                  ></div>
                </div>
                {/* Skeleton para título */}
                <div className="placeholder-glow">
                  <span className="placeholder col-8" style={{ height: '24px' }}></span>
                </div>
              </div>
              
              {/* Skeleton para lista de recursos */}
              <div className="flex-grow-1 mb-4">
                <div className="placeholder-glow">
                  {[1, 2, 3, 4].map((feature) => (
                    <div key={feature} className="d-flex align-items-start mb-2">
                      <div 
                        className="placeholder rounded-circle me-2 mt-1 flex-shrink-0"
                        style={{ width: '16px', height: '16px' }}
                      ></div>
                      <span className="placeholder col-10" style={{ height: '16px' }}></span>
                    </div>
                  ))}
                </div>
              </div>
              
              {/* Skeleton para preço */}
              <div className="text-center mb-3">
                <div className="placeholder-glow">
                  <span className="placeholder col-6" style={{ height: '32px' }}></span>
                </div>
              </div>
              
              {/* Skeleton para botão */}
              <div className="placeholder-glow">
                <span 
                  className="placeholder col-12 rounded-pill"
                  style={{ height: '44px' }}
                ></span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LoadingPlanCards;